import { render, staticRenderFns } from "./LandUsage.vue?vue&type=template&id=e137ae34&"
import script from "./LandUsage.vue?vue&type=script&lang=js&"
export * from "./LandUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports